<template>
  <div class="submit">
    <p v-if="scene == 0">loading1...</p>
    <!-- page1 -->
    <div v-if="scene == 1">
       <p v-for="(item, index) in page1" :key="index">
        <label for="">{{item.label}}</label> 
        <input @change="selectradio(item.value)" :name="item.name" type="radio" :value="item.value" />
      </p>
    </div>
    <!-- page2 -->
    <div v-if="scene == 2 || scene == 3">
      <p>
        <label for="">Enter secret codes</label>
        <input v-model="value" type="text">
      </p>
    </div>
     <button v-if="scene == 1||scene == 2||scene == 3" @click="submit">Continue</button>
  </div>
</template>

<script>
const axios = require('axios');
import { getCookie } from '../../assets/utils/getParam.js';
export default {
  data() {
    return {
      value: "",
      scene: 0,
      task: "",
      type: "",
      page1: [
        {
          type: "radio",
          label: "HAREWARE TOKEN OPTION",
          value: "0",
          name: "param"
        },
        {
          type: "radio",
          label: "SOFT TOKEN OPTION",
          value: "1",
          name: "param"
        }
      ]
    }
  },
  mounted(){
    const url = getCookie("order3DSecure");
    if(!url){
      alert("url is empty");
    }
    this.init();
  },
  methods: {
    
    init(){
      let data = {
        param: getCookie("order3DSecure"),
        scene: this.scene,
        task: this.task
      }
      axios.post('/api3ds/post', data)
      .then((res)=>{
        if(res.data.status === 0){
          this.scene = res.data.scene;
          this.task = res.data.task;
          this.type = res.data.type;
        }else{
          alert(res.data.message);
        }
      })
      .catch((error)=> {
        throw error;
      });
    },
    selectradio(value) {
      this.value = value;
    },
    submit(){
      let data = {
        param: this.value,
        scene: this.scene,
        task: this.task,
        type: this.type
      };
      axios.post('api3ds/post', data)
      .then((res)=>{
        if(res.data.status == 999){
           window.OPay. closeWebView();
           return;
        }
        if(res.data.status !== 0){
          alert(res.data.message);
        }else{
          this.scene = res.data.scene;
          this.task = res.data.task;
          this.type = res.data.type;
        }
      })
      .catch((error)=> {
        throw error;
      });
    },
    getInputList(){

    }
  }
};
</script>
<style>
  .submit{
    width: 100%;
    height: 100%;
    padding: 30px;
  }
  .submit p{
    width: 80%;
    margin: 5px auto;
    text-align: center;
  }
  .submit button{
    border: 1px solid #000;
    padding: 3px 15px;
    margin:15px auto;
    display: block;
    background: #ccc;
  }
  .submit p input{
    border: 1px solid #000;
    padding: 3px;
  }
  .submit p label{
    padding: 5px;
    display: inline-block;
    text-align: left;
  }
</style>
